import { TableCell as TableCellToExtend } from '@tiptap/extension-table-cell';

export const TableCell = TableCellToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: null
        }
    }
})
